import type {ValueType} from '@github-ui/custom-properties-types'

export const definitionTypeLabels: Record<ValueType, string> = {
  string: 'Text',
  ['single_select']: 'Single select',
  ['multi_select']: 'Multi select',
  boolean: 'True/false',
}
